/**
 * Lightweight analytics dispatch. Fires GA4 gtag events + Meta Pixel
 * if present. Falls back to console + posthog if enabled.
 */
export function track(event, params = {}) {
  try {
    if (typeof window === "undefined") return;
    // GA4
    if (window.gtag) window.gtag("event", event, params);
    // Meta Pixel
    if (window.fbq) window.fbq("trackCustom", event, params);
    // PostHog fallback
    if (window.posthog?.capture) window.posthog.capture(event, params);
  } catch (_) {
    // silent
  }
}
